// NOTE: HTML sanitation happens server-side inside the getPost server function
// (see src/server/sanitize-html.server.ts). Rendering here trusts the
// already-sanitized markup and keeps the sanitize-html library + its ~180 KiB
// of transitive deps out of the client bundle.
function slugify(text: string) {
  return text
    .toLowerCase()
    .replace(/<[^>]*>/g, "")
    .replace(/&[a-z]+;/g, " ")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .slice(0, 80);
}

export type TocItem = { id: string; text: string; level: 2 | 3 };

export function extractToc(html: string): { html: string; toc: TocItem[] } {
  const toc: TocItem[] = [];
  const used = new Set<string>();
  const out = html.replace(
    /<h([23])(\s[^>]*)?>([\s\S]*?)<\/h\1>/gi,
    (_m, lvl, attrs = "", inner) => {
      const text = String(inner).replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
      let id = slugify(text) || `section-${toc.length + 1}`;
      let n = 2;
      const base = id;
      while (used.has(id)) id = `${base}-${n++}`;
      used.add(id);
      toc.push({ id, text, level: Number(lvl) as 2 | 3 });
      const cleanAttrs = String(attrs).replace(/\sid\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
      return `<h${lvl}${cleanAttrs} id="${id}">${inner}</h${lvl}>`;
    },
  );
  return { html: out, toc };
}

export function PostBody({ html }: { html: string }) {
  return (
    <div
      className="post-body"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}